@if (isDialogVisible()) {
<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{enableCookiesDialogData.title}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <div class="dialog-content-padding">
        <span class="md-text uscb-padding-TB-20" [innerHTML]="enableCookiesDialogData.instructions"></span>
    </div>
</section>
}